import { Pipe, PipeTransform, inject } from '@angular/core';
import { FormattingService } from '@settings/data-access';

@Pipe({
    name: 'intlDateTime',
    pure: false,
    standalone: true
})
export class IntlDateTimePipe implements PipeTransform {
  private readonly formattingService = inject(FormattingService);

  /**
   * O valor chega já na hora de parede da conta: a conversão de UTC acontece na
   * fronteira com o backend (`DateInterceptor`, tanto para os campos `*Utc`
   * como para as exceções que o pedido declara em `withUtcDateFields`). Este
   * pipe só formata — reconverter aqui deslocaria o valor pelo offset da conta.
   */
  public transform(value: string | Date | number | null | undefined, options?: Intl.DateTimeFormatOptions): string {
    if (value == null) return '';
    return this.formattingService.formatDateTime(value, options);
  }
}